import { render, staticRenderFns } from "./CookieModal.vue?vue&type=template&id=db1fa0ee&scoped=true&"
import script from "./CookieModal.vue?vue&type=script&lang=js&"
export * from "./CookieModal.vue?vue&type=script&lang=js&"
import style0 from "./CookieModal.vue?vue&type=style&index=0&id=db1fa0ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1fa0ee",
  null
  
)

export default component.exports